import { FC, PropsWithChildren } from 'react';
import { DetailedSourceLanguageResponse } from 'src/types/languagesDomain';
import { TargetLanguagesContext } from './context';

export type TargetLanguagesProviderProps = {
  targetLanguages: DetailedSourceLanguageResponse[];
};

export const TargetLanguagesProvider: FC<PropsWithChildren<TargetLanguagesProviderProps>> = ({
  children,
  targetLanguages,
}) => {
  return (
    <TargetLanguagesContext.Provider value={targetLanguages}>
      {children}
    </TargetLanguagesContext.Provider>
  );
};
